/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/Meeting';
export default {
  date: 'Data',
  time: 'Hora',
  hours: '{howMany} h',
  minutes: '{howMany} min',
  today: 'Hoje',
  duration: 'Duração',
  topic: 'Título da reunião',
  voIPOnly: 'Apenas áudio da Internet',
  telephonyOnly: 'Apenas telefone',
  both: 'Áudio de telefone e Internet',
  thirdParty: 'Áudio de terceiros',
  meetingId: 'ID da reunião',
  password: 'Palavra-passe',
  video: 'Vídeo',
  audio: 'Áudio',
  scheduleFor: 'Agendar em nome de',
  [ASSISTED_USERS_MYSELF]: 'Eu',
  meetingOptions: 'Opções da reunião',
  meetingSettings: 'Definições da reunião',
  rcMeetingSettings: 'Definições de videoconferência',
  audioOptions: 'Opções de áudio',
  recurringMeeting: 'Reunião periódica',
  recurringNote: 'Nota: ativar este ao selecionar “Periodicidade”',
  joinBeforeHost: 'Permitir que os participantes entrem antes do anfitrião',
  turnOffCamera: 'Desativar a câmara dos participantes',
  turnOffHostCamera: 'Desativar a câmara do anfitrião ao entrar na reunião',
  requirePassword: 'Exigir palavra-passe',
  enterPassword: 'Introduzir palavra-passe',
  setPassword: 'Definir palavra-passe *',
  passwordEmptyError: 'Palavra-passe da reunião obrigatória',
  rcmPasswordInvalidError:
    'A palavra-passe tem de ter 1–10 carateres e números e não pode conter símbolos, exceto @, * ou -',
  rcmPasswordHintText:
    'A palavra-passe deve ter 1–10 carateres e números e não pode conter símbolos, exceto @, * ou -',
  usePersonalMeetingId: 'Utilizar ID da reunião pessoal',
  pmiChangeConfirm: 'Caso pretenda efetuar alterações na sua reunião pessoal, ',
  changePmiSettings: 'altere as definições do PMI',
  pmiSettingChangeAlert:
    'Se alterar as definições e agendar esta reunião, todas as reuniões com ID da reunião pessoal irão utilizar as definições mais recentes.',
  lockedTooltip: 'Esta definição é gerida pelo administrador da empresa',
  when: 'Quando',
  recurringDescribe:
    'Lembre-se de verificar a recorrência ou repetição no convite de calendário enviado aos participantes.',
} as const;

// @key: @#@"date"@#@ @source: @#@"Date"@#@
// @key: @#@"time"@#@ @source: @#@"Time"@#@
// @key: @#@"hours"@#@ @source: @#@"{howMany} hr"@#@
// @key: @#@"minutes"@#@ @source: @#@"{howMany} min"@#@
// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"duration"@#@ @source: @#@"Duration"@#@
// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
// @key: @#@"voIPOnly"@#@ @source: @#@"Internet audio only"@#@
// @key: @#@"telephonyOnly"@#@ @source: @#@"Telephone only"@#@
// @key: @#@"both"@#@ @source: @#@"Telephone and Internet audio"@#@
// @key: @#@"thirdParty"@#@ @source: @#@"3rd party audio"@#@
// @key: @#@"meetingId"@#@ @source: @#@"Meeting ID"@#@
// @key: @#@"password"@#@ @source: @#@"Password"@#@
// @key: @#@"video"@#@ @source: @#@"Video"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"meetingOptions"@#@ @source: @#@"Meeting options"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"rcMeetingSettings"@#@ @source: @#@"Video Meeting settings"@#@
// @key: @#@"audioOptions"@#@ @source: @#@"Audio options"@#@
// @key: @#@"recurringMeeting"@#@ @source: @#@"Recurring meeting"@#@
// @key: @#@"recurringNote"@#@ @source: @#@"Note: Enable this one when choosing \"Recurrence\""@#@
// @key: @#@"joinBeforeHost"@#@ @source: @#@"Allow participants to join before host"@#@
// @key: @#@"turnOffCamera"@#@ @source: @#@"Turn off camera for participants"@#@
// @key: @#@"turnOffHostCamera"@#@ @source: @#@"Turn off camera for host when joining meeting"@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"setPassword"@#@ @source: @#@"Set password *"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"rcmPasswordInvalidError"@#@ @source: @#@"Your password must be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"rcmPasswordHintText"@#@ @source: @#@"Your password should be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"usePersonalMeetingId"@#@ @source: @#@"Use Personal Meeting ID"@#@
// @key: @#@"pmiChangeConfirm"@#@ @source: @#@"If you want to make changes for your Personal Meeting, "@#@
// @key: @#@"changePmiSettings"@#@ @source: @#@"change PMI settings"@#@
// @key: @#@"pmiSettingChangeAlert"@#@ @source: @#@"If you change the settings and schedule this meeting, all of meetings with Personal Meeting ID will use the same latest settings."@#@
// @key: @#@"lockedTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"when"@#@ @source: @#@"When"@#@
// @key: @#@"recurringDescribe"@#@ @source: @#@"Please remember to check recurrence or repeat in your calendar invitation to your attendees."@#@
